import {
  AccordionContent,
  AccordionItem,
  Accordion,
  AccordionTrigger,
} from '@florencelabs/accordion';
import { MaterialSymbol } from '@florencelabs/icons';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';

import './footer-accordion.css';

interface AccordionData {
  id: string;
  title: string;
  links: {
    href: string;
    text: string;
    analyticsText: string;
  }[];
}

interface FooterAccordionProps {
  accordionData: AccordionData[];
}

export const FooterAccordion: React.FC<FooterAccordionProps> = ({
  accordionData,
}) => {
  const instanceId = useId();
  const { key } = useOrgContext();
  const { t } = useTranslation(key);
  const analytics = useAnalytics();
  return (
    <Accordion type={'multiple'}>
      {accordionData.map((section) => (
        <AccordionItem
          value={`${instanceId}-${section.id}`}
          key={section.id}
          className={'border-b'}
        >
          <AccordionTrigger
            customIcon={<MaterialSymbol name={'chevron_left'} />}
            headerClassName={'!border-0'}
            className={'mf-text-body-3-sans font-serif'}
          >
            {t(section.title)}
          </AccordionTrigger>
          <AccordionContent className={'!border-0'}>
            <div className={'mf-accordion__item__content grid gap-4'}>
              {section.links.map((link, index) => (
                <div key={index}>
                  <a
                    className={
                      'mf-link mf-link--site-montefiore mf-link--primary mf-link--base mf-link--no-underline mf-text-body-3-sans text-gray-500'
                    }
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: link.analyticsText,
                        linkType: 'link',
                      });
                    }}
                    href={link.href}
                    data-analytics-click-text={link.analyticsText}
                    data-analytics-link-type={'link'}
                  >
                    <span className={'mf-link__text'}>
                      <span
                        className={
                          'mf-link__text__inner mf-text-gray-500 font-bold'
                        }
                      >
                        {t(link.text)}
                      </span>
                    </span>
                  </a>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
